import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';

import { LoadingService } from '../../../shared/services/loading.service';


import { NotificationsService } from 'angular2-notifications';

import { TranslateService } from '../../../../app/translate';
import { UcSetupWornLimitService } from '../../setup-worn-limit/uc-setup-worn-limit.service';
import { UCInflection_CAT_WornLimitsVM, UCLinear_LIEBHERR_WornLimitsVM, UCPolynomial_KOMATSU_WornLimitsVM, UCStepped_ITM_WornLimitsVM, UC_WornLimitInfoVM, USCOPopulateData, USCO_PartInfoVM } from '../../setup-worn-limit/uc-setup-worn-limit.module';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-usco-data-comparison-dialog',
  templateUrl: './usco-data-comparison-dialog.component.html',
  styleUrls: ['./usco-data-comparison-dialog.component.scss']
})
export class UscoDataComparisonDialogComponent implements OnInit {

  selectedMake:string;
  selectedMakeID:number;
  
  selectedModel:string;
  selectedModelID:number;

  selectedCompType:string;
  selectedCompTypeID:number;

  selectedPartId:number;
  TTPartInfo:UC_WornLimitInfoVM;
  SteppedData: UCStepped_ITM_WornLimitsVM[]
  InflectionData: UCInflection_CAT_WornLimitsVM[]
  PolynomialData: UCPolynomial_KOMATSU_WornLimitsVM[]
  LinearData: UCLinear_LIEBHERR_WornLimitsVM[]

  PartNo:string;
  TT_USCOPart:string;
  TT_PartDesc:string;

  USCO_PartInfo:USCO_PartInfoVM[];
  isRowClick:boolean=false;
  selectedUSCOPart:string;
  constructor(
    private _translate: TranslateService,
    public dialogRef: MatDialogRef<UscoDataComparisonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notification: NotificationsService,
    private loadingService: LoadingService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,private _limitService: UcSetupWornLimitService,
  ) {}

  ngOnInit() {
   // this._componentservice.getModelList();
   // this._componentservice.getComponentType();
   console.log("data", this.data)
   this.selectedModel = this.data.selectedModel;
   this.selectedMakeID  =  this.data.selectedMakeID
  
  this.selectedMake=  this.data.selectedMake
  this.selectedMakeID=  this.data.selectedMakeID

  this.selectedCompType=  this.data.selectedCompType
  this.selectedCompTypeID=  this.data.selectedCompTypeID

  this.selectedPartId=this.data.selectedPartId;
   this.TT_PartDesc=this.data.TT_PartDesc;
  this.loadCompartUCWornLImitInfoTrackTreads();
  this.LoadUSCOPartDetails();
  }

  onNoClick() {
    this.dialogRef.close(true);
  }


  loadCompartUCWornLImitInfoTrackTreads() {
    console.log("data_", this.selectedPartId, )
    this._limitService.GetCompartUCWornLimitData(this.selectedPartId,0).subscribe(res => {
      this.TTPartInfo = res;
     // this.selectedMethod = res.Method;
      this.SteppedData = res.SteppedData;
      this.InflectionData = res.InflectionData;
      this.PolynomialData = res.PolynomialData;
      this.LinearData = res.LinearData;
      //this.MakeName = res.MakeName;
      //this.Component = res.Component;
      //this.ComprtType = res.ComprtType;
      this.PartNo = res.PartNo;

      this.TT_USCOPart=res.USCOPartNo;
      
     // this.MethodName = res.MethodName;
     // this.labelPart = res.PartNo;
      //this.labelMake = res.MakeName;
      console.log("result__", res)
    })

  }


  LoadUSCOPartDetails(){
    var infModel = new USCOPopulateData();
    infModel.CompType = this.selectedCompType;
    infModel.Make=this.selectedMake;
    infModel.Models=this.selectedModel;
    this._limitService.PostCompartUCWornLimitInfo(infModel).subscribe(res=>{
      console.log("res__",res)
      this.USCO_PartInfo =res;
    })
  }

  USCOPartRowClick(item:USCO_PartInfoVM){
    this.isRowClick=true;
    this.selectedUSCOPart = item.USCOPartNo;
  }

  Update(){
    this._limitService.UpdateUSCOPart(this.selectedPartId, this.selectedUSCOPart).subscribe(res=>{
      if(res==true){
        this.notification.success("Sucessfully update the USCO Part No")
      }else{
        this.notification.error("Failed tp update the USCO Part No")

      }
    })
  }
}
